/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { NBCall } from '../../../bridges/nebula/index.js';
import '../../../index.es-142c5680.js';
import '../../../bridge-adpter-api-0316c034.js';
import '../../../tslib.es6-e01eabb2.js';

function getNetworkType(params) {
    // https://smallfish.antfin-inc.com/jsapi/getNetworkType.html
    var formatOutput = function (ret) {
        var type = "".concat(ret === null || ret === void 0 ? void 0 : ret.networkInfo);
        switch (type) {
            case 'WIFI':
            case '5G':
            case '4G':
            case '3G':
            case '2G':
                break;
            case 'NOTREACHABLE':
                type = 'NONE';
                break;
            case 'UNKNOWN':
            case 'WWAN':
            default:
                type = 'UNKNOWN';
                break;
        }
        return { networkType: type };
    };
    NBCall('getNetworkType', params, { formatOutput: formatOutput });
}

export { getNetworkType as default };
